/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HarvestInputs */

const en_harvest = /** @type {(inputs: HarvestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harvest`)
};

const es_harvest = /** @type {(inputs: HarvestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosecha`)
};

/**
* | output |
* | --- |
* | "Harvest" |
*
* @param {HarvestInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const harvest = /** @type {((inputs?: HarvestInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HarvestInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_harvest(inputs)
	return es_harvest(inputs)
});